export const locale = {
    lang: 'en',
    data: {
        'DOCUMENT_VERIFY': {
            'INITIAL_TEXT': 'Document verification',
            'EMAIL': 'Email',
            'ID': 'Document private ID',
            'FORGOT_PASSWORD': 'Forgot Password?',
            'VERIFY': 'Verify document',
            'LOGIN': 'Login',
            'BACK_TO_PANEL': 'Back to the panel',
            'ACCES_PANEL': 'Do you want to access the panel?',
            'NO_ACCOUNT': 'Don\' have an account?',
            'CREATE_ACCOUNT': 'Create an account',
            'EMAIL_REQUIRED': 'Email is required',
            'INVALID_EMAIL': 'Please enter a valid email address',
            'ID_REQUIRED': 'Identifier is required',
            'FILE': "File",
            'CHOOSE_FILE': "Choose a file",
            'VERIFIED': "Is the original document",
            'NOT_VERIFIED': "The document does not correspond or has been modified",
            'BACK_TO_VERIFY': "Recheck",
        }
    }
};
